/*
 * @Description: 功能描述
 * @Author: yy
 * @Date: 2020-08-17 17:56:26
 * @LastEditors: yy
 * @LastEditTime: 2020-08-17 17:57:41
 */

import React from 'react';
import SetRedisInfo from './SetRedisInfo';
import Layout from '../../components/Layout/Layout';


const title='已完成文章修改'
export default {

  path: '/setRedisInfo',

  async action() {
    
    return {
      title:title,
      component: <Layout><SetRedisInfo  title={title}/></Layout>,
    };
  },

};



// WEBPACK FOOTER //
// src/routes/setRedisInfo/index.js